export const GET_ALERTS = "GET_ALERTS"
export const RESET_ALERTS = "RESET_ALERTS"
export const LOAD_ALERTS = "LOAD_ALERTS"
export const STOP_LOAD_ALERTS = "STOP_LOAD_ALERTS"
export const CURRENT_CRITERIA = "CURRENT_CRITERIA"
export const MESSAGE_TYPE = "MESSAGE_TYPE"
export const TEMPLATES = "TEMPLATES"
export const CURRENCY = "CURRENCY"
export const CREATE_CRI = "CREATE_CRI"
export const Filter_Messages = "Filter_Messages"
export const DELETE_CRI="DELETE_CRI"
export const GET_Fields="GET_Fields"


// INTERNAL_ALERTS
export const SEARCH_INTERNAL_ALERTS = "SEARCH_INTERNAL_ALERTS";
export const RESET_INTERNAL_ALERTS = "RESET_INTERNAL_ALERTS";
export const SET_PROCESSING_INTERNAL_ALERTS = "SET_PROCESSING_INTERNAL_ALERTS";
export const STOP_PROCESSING_INTERNAL_ALERTS = "STOP_PROCESSING_INTERNAL_ALERTS";
export const LOAD_COUNTRIES = "LOAD_COUNTRIES";
export const LOAD_CURRENCIES = "LOAD_CURRENCIES";



// FOLLOWING_NOTIFICATION 
export const SEARCH_INTERNAL_NOTIFICATOIN = "SEARCH_INTERNAL_NOTIFICATOIN";
export const RESET_INTERNAL_NOTIFICATOIN = "RESET_INTERNAL_NOTIFICATOIN";
export const SET_PROCESSING_INTERNAL_NOTIFICATOIN = "SET_PROCESSING_INTERNAL_NOTIFICATOIN";
export const STOP_PROCESSING_INTERNAL_NOTIFICATOIN = "STOP_PROCESSING_INTERNAL_NOTIFICATOIN";

//customerList 
export const SEARCH_CUSTOMER_LIST = "SEARCH_CUSTOMER_LIST";
export const RESET_CUSTOMER_LIST = "RESET_CUSTOMER_LIST";
export const SET_PROCESSING_CUSTOMER_LIST = "SET_PROCESSING_CUSTOMER_LIST";
export const STOP_PROCESSING_CUSTOMER_LIST = "STOP_PROCESSING_CUSTOMER_LIST";
export const LOAD_MEESAGETYPES = "LOAD_MEESAGETYPES";
export const LOAD_TEMPLATE = "LOAD_TEMPLATE";
export const GROUPS = "GROUPS"
export const SELECTED_USER = "SELECTED_USER"
export const GET_CONFIGURATION = "GET_CONFIGURATION"




//CustomerGroups
export const CREATE_GROUP = "CREATE_GROUP"
export const RESET_GROUPS = "RESET_GROUPS";
export const DELETE_GROUP = "DELETE_GROUP"
export const CUSTOMERS_IN_GROUP = "CUSTOMERS_IN_GROUP";
export const LOAD_NOTIFICATION = "LOAD_NOTIFICATION";
export const All_GROUPS = "ALL_GROUPS"
export const RESET_CUSTOMER_GROUPS = "RESET_CUSTOMER_GROUPS"
export const CUSTOMERS_LIST = "CUSTOMERS_LIST"
export const SET_PROCESSING_SUBSCRIBERS_GROUP = "SET_PROCESSING_SUBSCRIBERS_GROUP"

